/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IModulo from 'Infotrack@Modelos/administracion/modulo/entidades/modulo';
import React from 'react';
import ModuloCM from '../controladorModelo/moduloCM';
import { acciones, IEstadoModulo } from '../reductorModulo';
import ModuloVista from '../vista/tablaModuloVista';

const moduloCM = new ModuloCM();

const TableModuloCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [modulos, setModulos] = React.useState<IModulo[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoModulo>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarModulo();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarModulo = () => {
        manejadorIndicadorCargaGlobal(true);
        moduloCM.consultarModulo().then((modulos) => {
            setModulos(modulos);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadModulo?: IModulo) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadModulo, tipoFormulario } });
    };

    const confirmarEliminacion = (modulo: IModulo) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarModulo(modulo),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };
    const eliminarModulo = (modulo: IModulo) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        moduloCM.eliminarModulo(modulo).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <ModuloVista
            modulos={modulos}
            cargarModulo={cargarModulo}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableModuloCV;
